import { useTranslation } from 'react-i18next';

import { Button } from '@arco-design/web-react';
import { IconApps, IconList } from '@arco-design/web-react/icon';
import classnames from 'classnames';

import styles from './index.module.less';
import { ListSwitcherProps } from './types';

/**  列表/卡片切换按钮  */
export function ListSwitcher({ displayType, onChange, switchClassName, className, style }: ListSwitcherProps) {
  const { t } = useTranslation();
  return (
    <div className={classnames(styles['view-switch'], switchClassName, className)} style={style}>
      {
        <Button
          onClick={() => onChange(displayType === 'table' ? 'card' : 'table')}
          type="default"
          icon={displayType === 'card' ? <IconList /> : <IconApps />}
        >
          {displayType === 'table' ? t('components:card') : t('common:list')}
          {t('common:view')}
        </Button>
      }
    </div>
  );
}
